import React from "react";
import CurvedBelow from "@images/Curves/CurvedLinesBelowData.svg";
import CirclesAbove from "@images/Curves/CirclesAboveData.svg";
import { BadgeCheckIcon } from "@heroicons/react/outline";

/**
 *
 *    Helpers
 *
 */

export type DataSectionType = {
  id: string;
  title: string;
  number: string;
  dataType: string;
};

const DataSection = (props: { data: Readonly<DataSectionType[]> }) => {
  const colors = ["#38B9E2", "#38E2A5", "#82CA69", "#C7DB4E"];

  return (
    <div className="div-block mt-5 hidden lg:block">
      {/* <div className="flex flex-col text-center p-20 pb-0"> */}
      <div className="flex flex-col text-center">
        <img
          src={CirclesAbove}
          style={{
            minWidth: "100%",
            maxHeight: "100%",
            maxWidth: "100%",
            width: "100%",
            position: "relative",
          }}
          alt="circles_above_data"
        />
        <div
          id="data_between_curves"
          className="grid w-full grid-flow-row grid-cols-4 px-[8%] pb-4"
        >
          {props.data.map((value, ix) => {
            return (
              <div
                className="arrow-data grid grid-cols-1 grid-rows-[1fr_96px] gap-2"
                key={value.id}
              >
                <div
                  className="mb-0 text-base font-medium"
                  style={{ color: colors[ix] }}
                >
                  {value.title.toUpperCase()}
                </div>
                <BadgeCheckIcon
                  className="mx-auto w-24 transition hover:scale-110"
                  style={{ color: colors[ix] }}
                />
                {/*</DataSubtitle>*/}
              </div>
            );
          })}
        </div>
        <img
          src={CurvedBelow}
          className="mb-0 min-h-[180px]"
          style={{
            marginBottom: "-2px",
            maxHeight: "100%",
            maxWidth: "100%",
            width: "100%",
            position: "relative",
            height: "100%",
          }}
          alt="curves below data"
        />
      </div>
    </div>
  );
};

export default DataSection;
